/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToRem, coloredScrollBar, themeV2 } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION ADMIN SECTION : STYLES --------------- ++++++++++ */
export default theme => ({
  sitethemesection: {
    '& .inlinemessage .details': {
      alignItems: 'flex-start',
      '& .icon': {
        marginTop: '2px'
      }
    },
    '& .collapsable': {
      '& .replycaret': {
        display: 'none'
      }
    },
    '& .collapsable.opened': {
      minHeight: 'auto',
      maxHeight: pxToRem(3000),
      '& .replycaret': {
        display: 'block'
      }
    },
    '& .stylesection': {
      // maxHeight: '100vh',
      // overflowY: 'scroll',
      padding: `8px 16px`,
      // extend: coloredScrollBar(themeV2.color.base.scrollbar)
    },
    '& .themesection': {
      position: 'sticky',
      top: '6em', // 1em + min-height of the configv2controller header
      alignSelf: 'flex-start' // needed to ensure its sticky within the container
    },
    '& .sectiongroupv2': {
      '& > .header': {
        width: '100%'
      }
    }
  },
  [`@media only screen and (max-width:1600px)`]: {
      sitethemesection: {
        '& .stylesection': {
          maxWidth: '50%',
          padding: '4px',
          '&.sidebarOpen-true': {
            maxWidth: '45%'
          },
          '& .primarycolor': {
            flexWrap: 'wrap'
          }
        },
        '& .themesection': {
          '& .content': {
            padding: '16px 8px'
          }
        }
      }
  }

});
